import { useState } from 'react';
import classNames from 'classnames';
import { saveAs } from 'file-saver';
import moment from 'moment';
import {
  API,
  Field2 as Field,
  TableAllocations,
} from 'vibeguide';

function OrderSegmentAllocationOverview({
  className,
  style,
  orderId = null,
  segmentId = null,
  currencyCode = null,
}) {
  const [dataSource, setDataSource] = useState('company');

  /**
   * Get the API endpoint to use for the table by data source
   */
  const getTableEndpoint = () => {
    switch (dataSource) {
      case 'banner':
        return API.Order.Segment.Summary.banners;

      case 'location':
        return API.Order.Segment.Summary.locations;

      case 'company':
      default:
        return API.Order.Segment.Summary.companies;
    }
  };

  /**
   * Get the label to use for the table based on the selected data source
   */
  const getTableLabel = () => {
    switch (dataSource) {
      case 'banner':
        return 'Banners';

      case 'location':
        return 'Locations';

      case 'company':
      default:
        return 'Companies';
    }
  };

  /**
   * When the data source is changed reload the table
   */
  const onChangeDataSource = (e) => {
    const {
      target: {
        value,
      },
    } = e;

    setDataSource(value);
    document.dispatchEvent(new Event('onUpdateAllocation'));
  };

  /**
   * Export to CSV file
   */
  const onExport = async (data) => {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });
    const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
    saveAs(blob, `${getTableLabel().toLowerCase()}-allocations-${timestamp}.csv`);
  };

  if (!orderId || !segmentId) {
    return null;
  }

  return (
    <div
      className={classNames('OrderSegmentAllocationOverview', className)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
        ...style,
      }}
    >
      <TableAllocations
        dataType="order-segment"
        dataSource={dataSource}
        currencyCode={currencyCode}
        fetch={getTableEndpoint()}
        fetchProps={{
          filters: {
            orderId,
            segmentId,
          },
        }}
        defaultSortBy={{
          label: 'Name',
          attr: 'name',
          direction: 'asc',
        }}
        paginator
        paginatorProps={{
          label: getTableLabel(),
          urlPaging: true,
          urlFilters: true,
        }}
        toolbarProps={{
          customButtons: [
              (
                <Field
                  key="custom-data-source"
                  type="select"
                  name="dataSource"
                  value={dataSource}
                  tabIndex={14}
                  options={[
                    { label: 'View by Company', value: 'company' },
                    { label: 'View by Banner', value: 'banner' },
                    { label: 'View by Location', value: 'location' },
                  ]}
                  onChange={onChangeDataSource}
                />
              ),
            ]
        }}
        csv
        csvProps={{
          onExport,
        }}
      />
    </div>
  );
}

export default OrderSegmentAllocationOverview;
